var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.52,25.83c-4.35,0-7.89-3.54-7.89-7.89s3.54-7.89,7.89-7.89,7.89,3.54,7.89,7.89-3.54,7.89-7.89,7.89ZM50.52,12.04c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89,5.89-2.64,5.89-5.89-2.64-5.89-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.01,90.24c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.03,90.24c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.52,90.24c-.55,0-1-.45-1-1v-29.72c0-.55.45-1,1-1s1,.45,1,1v29.72c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.97,66.48c-.55,0-1-.45-1-1v-27.11c0-2.69-2.19-4.88-4.88-4.88h-19.38c-2.69,0-4.88,2.19-4.88,4.88v24.91c0,.55-.45,1-1,1s-1-.45-1-1v-24.91c0-3.8,3.09-6.88,6.88-6.88h19.38c3.8,0,6.88,3.09,6.88,6.88v27.11c0,.55-.45,1-1,1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.13,16.32c-4.35,0-7.89-3.54-7.89-7.89S12.78.53,17.13.53s7.89,3.54,7.89,7.89-3.54,7.89-7.89,7.89ZM17.13,2.53c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89,5.89-2.64,5.89-5.89-2.64-5.89-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.62,80.73c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.64,80.73c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.13,80.73c-.55,0-1-.45-1-1v-29.71c0-.55.45-1,1-1s1,.45,1,1v29.71c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.43,54.77c-.55,0-1-.45-1-1v-24.91c0-3.8,3.09-6.89,6.88-6.89h19.38c3.8,0,6.88,3.09,6.88,6.89v1.39c0,.55-.45,1-1,1s-1-.45-1-1v-1.39c0-2.69-2.19-4.89-4.88-4.89H7.31c-2.69,0-4.88,2.19-4.88,4.89v24.91c0,.55-.45,1-1,1Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.37,16.32c-4.35,0-7.89-3.54-7.89-7.89s3.54-7.89,7.89-7.89,7.89,3.54,7.89,7.89-3.54,7.89-7.89,7.89ZM82.37,2.53c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89,5.89-2.64,5.89-5.89-2.64-5.89-5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.87,80.73c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.86,80.73c-.55,0-1-.45-1-1v-46.83c0-.55.45-1,1-1s1,.45,1,1v46.83c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.37,80.73c-.55,0-1-.45-1-1v-29.71c0-.55.45-1,1-1s1,.45,1,1v29.71c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.06,54.77c-.55,0-1-.45-1-1v-24.91c0-2.69-2.19-4.89-4.88-4.89h-19.38c-2.69,0-4.88,2.19-4.88,4.89v1.39c0,.55-.45,1-1,1s-1-.45-1-1v-1.39c0-3.8,3.09-6.89,6.88-6.89h19.38c3.8,0,6.88,3.09,6.88,6.89v24.91c0,.55-.45,1-1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.312e381d5c0732d074437e28ef907765.svg";
export { ForwardRef as ReactComponent };